import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              精选内容
            </h2>
            <p className="text-foreground-600 text-base">
              编辑精选的高品质内容，为您推荐最值得观看的节目
            </p>
          </div>
          <Link
            to="/category/xinwen"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            浏览更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}